"use client";

import { TitleH2, TitleH3 } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { ComponentProps } from "react";
import {
  blackDesign,
  grayDesign,
  modernDesign,
  whiteDesign,
} from "../../../../public/images/floor-plan-designs";

type DesignDescriptionProps = ComponentProps<typeof TitleH3> &
  ComponentProps<typeof Image> & {
    description: string;
    subDescription?: string;
    imageLeft?: boolean;
  };

const DescriptionContainer = ({ ...props }: DesignDescriptionProps) => {
  return (
    <div
      className={`flex flex-col items-center gap-8 ${props.imageLeft ? "lg:flex-row-reverse" : "lg:flex-row"}`}
    >
      <div className="flex flex-col gap-5">
        <TitleH2 title={props.title} />
        <p className="text-ring">{props.description}</p>
        <p>
          {props.subDescription && (
            <span className="text-ring">{props.subDescription}</span>
          )}
        </p>
      </div>
      <div className="gs--design-gallery__description-image">
        <Image
          src={props.src}
          alt={props.alt}
          width={550}
          height={550}
          className="block"
        />
      </div>
    </div>
  );
};

const DesignDescription = () => {
  const tH = useTranslations("floorPlanDesigns.designContainer");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col items-center gap-10">
        <DescriptionContainer
          title={tH("black.title")}
          description={tH("black.description")}
          subDescription={tH("black.subDescription")}
          src={blackDesign}
          alt={"Grundriss Design Schwarz"}
        />
        <DescriptionContainer
          title={tH("blackWhite.title")}
          description={tH("blackWhite.description")}
          subDescription={tH("blackWhite.subDescription")}
          src={whiteDesign}
          alt={"Grundriss Design Weiß"}
          imageLeft
        />
        <DescriptionContainer
          title={tH("gray.title")}
          description={tH("gray.description")}
          subDescription={tH("gray.subDescription")}
          src={grayDesign}
          alt={"Grundriss Design Grau"}
        />
        <DescriptionContainer
          title={tH("modern.title")}
          description={tH("modern.description")}
          subDescription={tH("modern.subDescription")}
          src={modernDesign}
          alt={"Grundriss Design Modern"}
          imageLeft
        />
      </div>
    </div>
  );
};

export default DesignDescription;
